// imports
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

// local imports
import { uiActions } from '../../store';

export const STORAGE_KEY = 'nwdc_info_dialog_dismissed_at';
const THIRTY_DAYS_MS = 30 * 24 * 60 * 60 * 1000;

/**
 * InfoDialogInitializer
 *
 * Opens the InfoDialog automatically on first page load, and again after
 * 30 days have elapsed since the user last dismissed it.
 * Persists the dismissal timestamp in localStorage.
 */
export const InfoDialogInitializer = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const lastDismissedDateTime = localStorage.getItem(STORAGE_KEY);
    const parsed = Number(lastDismissedDateTime);
    const shouldOpen = !lastDismissedDateTime || isNaN(parsed) || Date.now() - parsed > THIRTY_DAYS_MS;

    if (shouldOpen) {
      dispatch(uiActions.setInfoDialogOpen(true));
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
};

export default InfoDialogInitializer;
